import Component from "../abstracts/Component";
import AnimateListingComponent from '../components/AnimateListingComponent';
import queryString from 'query-string';
import {buildFullQuery, buildQuery, listingLayoutParams, sortByParams} from "../utils/SearchUrlUtil";
import {getQueryParameterByName} from "../utils/Utils";
import {getFocusElement, hasFocusElement, replacePageInHistory} from "../utils/BrowserHistoryUtils";
import TrackingComponent from "../components/TrackingComponent";

export default class FiltersLogic extends Component {
  get SELECTORS() {
    return {
      main: '[data-filters]',
      filtersDropdown: '.js-filter-dropdown',
      filterBtnWithCounter:'[data-total-filters]',
      pagersContainer: '.js-item-pagination',
      sortBy: '[data-sortby]'
    }
  }

  get CLASSES() {
    return {
      layerVisible: 'show',
      layerVisibleReset: 'show-active',
      buttonCloseLayer: 'collapsed',
      sortBy: 'c-f-b__sort-container'
    }
  }

  get QUERY_PARAMS() {
    return {
      base: () => {
        return `?${listingLayoutParams(this.listingLayout)}=true&partial=true&q=%3A${sortByParams(this.sortBy)}`;
      }
    }
  }

  constructor() {
    super();
    this.sortBy = '';
    this.sortMethod = '';
    this.sortName = '';
    this.sortType = '';
    this.listingLayout = '';
    this.page = 0;
    this.main = document.querySelector(this.SELECTORS.main);
    this.trigger = document.querySelector(this.main.dataset.filtersTrigger);
    this.TrackingComponent = new TrackingComponent();
  }

  forceClose() {
    this.main.classList.contains(this.CLASSES.layerVisibleReset) ? this.main.classList.remove(this.CLASSES.layerVisibleReset) : this.main.classList.remove(this.CLASSES.layerVisible);
    this.trigger.classList.contains(this.CLASSES.buttonCloseLayer) ? this.trigger.classList.add(this.CLASSES.buttonCloseLayer) : this.trigger.classList.add(this.CLASSES.buttonCloseLayer);
    this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
  }

  toggleFiltersLayer() {

    if (this.main.classList.contains(this.CLASSES.layerVisible)) {
      setTimeout(() => {
        document.querySelector(`${this.main.dataset.filtersLayer} input[type="checkbox"]`).focus();
      }, 200);

      this.$on('keyup.filtersLayer', ({event}) => {
        if (event.which === 27) {
          this.forceClose();
          setTimeout(() => {
            document.querySelector(this.main.dataset.filtersTrigger).focus();
            this.$off('keyup.filtersLayer', this.main.dataset.filtersForm);
          }, 200);
        }
      }, this.main.dataset.filtersForm);
    }

   // TODO: DANGER - not working collapse with use jquery 3.5
   return this.$customEvents.BACKDROP_EVENTS[`${this.main.classList.contains(this.CLASSES.layerVisible) ? 'show' : 'hide'}`]
  }

  getPage(query = '', showLoader = true, emitQuery = true, pagequery = '', skipScroll=false) {
    this.sortBy = sortByParams(this.sortBy);
    this.listingLayout = listingLayoutParams(this.listingLayout);

    const fullQuery = buildFullQuery({
      textSearch: this.main.dataset.filtersTextsearch,
      query: query,
      size: this.main.dataset.filtersPagesize,
      page: pagequery,
      sortBy: this.sortBy,
      listingLayout: this.listingLayout
    });

    const ajaxConf = {
      type: 'GET',
      url: fullQuery,
    };

    if (emitQuery) ajaxConf.success = () => {
      this.$emit(this.$customEvents.FILTERS_EVENTS.updated, {query: fullQuery, skipScroll});
    }

    if (showLoader) ajaxConf.beforeSend = () => {
      this.$emit(this.$customEvents.LOADER_EVENTS.show);
    }

    return $.ajax(ajaxConf);
  }

  buildQuery() {
    return buildQuery(this.main.dataset.filtersForm);
  }

  renderPage(res, append) {

    // tracking action (see TrackingComponent.js)
    this.$emit(this.$customEvents.TRACKING.loadMore, res);
    this.forceClose();

    let response = new DOMParser().parseFromString(res, 'text/html');
    let url = response.URL;
    this.main = document.querySelector(this.SELECTORS.main);
    let container = document.querySelector(this.main.dataset.filtersResult);
    let filtersSelectedContainer = document.querySelector(this.main.dataset.filtersSelected);
    let responseFiltersSelected = response.querySelector(this.main.dataset.filtersSelected);
    let responseFiltersResult = response.querySelector(this.main.dataset.filtersResult);
    let infiniteScrollButton = document.querySelector('[data-infinite-scroll]');
    const pageSupportsPagination = $(this.SELECTORS.pagersContainer).length > 0;
    const newURL = url.replace("isRefineSearch=true", "isRefineSearch=false");

    replacePageInHistory(newURL.replace(/\s.*/, ""),{},"", false);
    let sortBy = response.querySelector(this.SELECTORS.sortBy);
    this.sortMethod = sortBy.dataset.sortMethod;
    this.sortType = sortBy.dataset.sortType;

    if (infiniteScrollButton) {
      let parsedQuery = queryString.parse(infiniteScrollButton.dataset.infiniteScrollQuery);
      parsedQuery.page = parseFloat(parsedQuery.page) + 1;
      document.querySelector('[data-infinite-scroll]').setAttribute('data-infinite-scroll-query', `?${queryString.stringify(parsedQuery)}`); // next page
      // update number of filtered products
      if (response.querySelector('[data-infinite-scroll]')) {
        document.querySelector('[data-infinite-scroll]').innerHTML = response.querySelector('[data-infinite-scroll]').innerHTML;
      }
    } else if(pageSupportsPagination) {
      this.updatePager(response);
    }

    if (append) {
      //clearTimeout(this.focusTimeout);
      if (responseFiltersResult) {
        let rows = responseFiltersResult.querySelectorAll('.js-products-row');

        for(let child of rows) {
          container.appendChild(child);
        }
      }
    } else {
      let btnWithCounter = document.querySelector(this.SELECTORS.filterBtnWithCounter);

      if (responseFiltersResult) {
        container.innerHTML = responseFiltersResult.innerHTML;
      }

      // se ci sono filtri li aggiungo
      if (responseFiltersSelected) {
        filtersSelectedContainer.innerHTML = responseFiltersSelected.innerHTML;

        // logica mobile => aggiungo un counter vicino al trigger
        let count = responseFiltersSelected.querySelector(this.main.dataset.filtersCount).innerText;

        if (parseFloat(count)) {
          btnWithCounter.dataset.totalFilters = count;
        } else {
          btnWithCounter.dataset.totalFilters = '0';
        }

      } else {
        const filtersCount = document.querySelector(this.main.dataset.filtersCount);
        if (filtersCount) {
          btnWithCounter.dataset.totalFilters = '0';
        }
      }

      this.$emit(this.$customEvents.FILTERS_EVENTS.updated, {
        updatedButton: infiniteScrollButton ? infiniteScrollButton.parentElement.innerHTML : false,
        hideButton: !response.querySelector('[data-infinite-scroll]')
      });
    }

    this.$emit(this.$customEvents.FILTERS_EVENTS.pageLoaded, {response: response});
    this.$emit(this.$customEvents.LOADER_EVENTS.hide);

    this.AnimateListingComponent = new AnimateListingComponent(this);
    this.AnimateListingComponent.initAll();
  }

  updatePager(responseResult) {
    const $html = $(responseResult);
    const pagersContainer = this.SELECTORS.pagersContainer;
    const newPagination = $html.find(pagersContainer);
    const $oldPagination = $(pagersContainer);
    $oldPagination.empty().append(newPagination.children())
  }

  setPagination() {
    let dataInfiniteScroll = document.querySelector('[data-infinite-scroll]');
    if (dataInfiniteScroll) {
      dataInfiniteScroll.classList.remove('d-none');
      dataInfiniteScroll.style.display = '';
    }
  }

  bindFilters() {
    const zIndex = window.getComputedStyle(this.main).getPropertyValue('z-index');
    const main = document.querySelector(this.SELECTORS.filtersDropdown);

    this.$on('click.filters', ({event}) => {
      event.preventDefault();
      const zIndex = window.getComputedStyle(this.main).getPropertyValue('z-index');
      this.$emit(this.toggleFiltersLayer(), {
        classes: 'clear',
        zIndex: zIndex - 1
      });
    }, this.main.dataset.filtersTrigger);
  }

  bindEvents() {
    // view more button
    this.$on(this.$customEvents.INFINITE_SCROLL_EVENTS.next, ({payload}) => {
      this.getPage(this.buildQuery(), true, true, payload.page).then(res => this.renderPage(res, true));
    });

    this.$on(this.$customEvents.PAGE_LAYOUT_EVENTS.changed, ({payload}) => {
      this.listingLayout = payload.layout;
      this.getPage(this.buildQuery()).then(res => this.renderPage(res)).then(function () {
        document.querySelector(".js-infinite-scroll").classList.remove("d-none");
      });
    });

    this.$on(this.$customEvents.SORT_BY_EVENTS.changed, ({payload}) => {
      this.sortBy = payload.value;
      this.sortName = payload.name;
      this.getPage(this.buildQuery()).then(res => {
        this.renderPage(res);
        this.TrackingComponent.actions.sortTracking(this.sortName, this.sortMethod, this.sortType);
        this.topFunction();
      });
    });

    this.$on(this.$customEvents.BACKDROP_EVENTS.hidden, this.forceClose(), this.main.dataset.filtersTrigger);

    this.$on('click.filtersReset', ({event,payload}) => {
      const checkboxes = document.querySelectorAll(this.main.dataset.filtersCheckbox);

      if (checkboxes) {
        checkboxes.forEach(checkbox => {
          checkbox.checked = false
          checkbox.parentElement.parentElement.classList.remove('disabled');
          checkbox.disabled = false;
        });
      }
      this.setPagination();

      $(this.main.dataset.filtersLayer).trigger('submit.filters');
    }, 'body', this.main.dataset.filtersReset);

    this.$on('change.filters', ({event,payload}) => {
      let query = this.buildQuery();
      const {page,$focusElement,skipScroll} = payload || {}

      this.getPage(`${query}`, false, true, page, skipScroll).then(res => {
        const response = new DOMParser().parseFromString(res, 'text/html');
        const originalCheckboxes = document.querySelectorAll(this.main.dataset.filtersCheckbox);

        for (let checkbox of originalCheckboxes) {
          const testEl = response.querySelector(`#${checkbox.id}`);

          if (!testEl) {
            checkbox.parentElement.parentElement.classList.add('disabled');
            checkbox.checked = false;
            checkbox.disabled = true;
          } else {
            checkbox.parentElement.parentElement.classList.remove('disabled');
            checkbox.disabled = false;
          }
        }

        if (document.querySelector('[data-infinite-scroll]') == null) return false;
        this.setPagination();

        if(!$focusElement.length > 0) {
          this.topFunction();
        } else {
          this.timedOutScrollToElement($focusElement);
        }
      });
    }, 'body', this.main.dataset.filtersCheckbox);

    if (!window.matchMedia('(max-width:767px)').matches) {
      this.$on('click.filtersRemove', ({event}) => {
        const checkboxValue = event.currentTarget.dataset.filtersValue;
        const checkboxCombinedValues = event.currentTarget.dataset.filtersCombinedValues;
        const checkbox = document.querySelector(`input[value="${checkboxValue}"]`);
        if (typeof checkboxCombinedValues !== 'undefined') {
          const vals = checkboxCombinedValues.split("-");
          for (let i = 0 ; i < vals.length; i++) {
            if (vals[i].trim() != '') {
              let checkbox = document.querySelector(`input[value="${vals[i].trim()}"]`);
              if (checkbox) {
                checkbox.checked = false;
              }
            }
          }
        }
        if (checkbox) {
          checkbox.checked = false;
          $(checkbox).trigger('change.filters');

          this.getPage(this.buildQuery(), false, true).then(res => {
            const response = new DOMParser().parseFromString(res, 'text/html');
            const originalCheckboxes = document.querySelectorAll(this.main.dataset.filtersCheckbox);

            originalCheckboxes.forEach(checkedCheckbox => {
              const toCheck = response.querySelector(`#${checkedCheckbox.id}`);

              if (!toCheck) {
                checkedCheckbox.parentElement.parentElement.classList.add('disabled');
                checkedCheckbox.checked = false;
                checkedCheckbox.disabled = true;
              } else {
                checkedCheckbox.parentElement.parentElement.classList.remove('disabled');
                checkedCheckbox.disabled = false;
              }
            });

            this.setPagination();
            this.renderPage(res)
          });
        }
      }, 'body', this.main.dataset.filtersRemove);
    }

    $(document).ready(() => {
      const checkboxes = [...document.querySelectorAll(this.main.dataset.filtersCheckbox)];
      const originalCheckboxes = checkboxes.filter((checkbox) => checkbox.checked === true);

      const $focusElement = $(getFocusElement());
      const handleFocus = hasFocusElement() && $focusElement.length > 0;

      let paginationPayload = [
        {
          page: getQueryParameterByName("page"),
          $focusElement,
          skipScroll:true
        }
      ];

      if(originalCheckboxes.length > 0) {
        $(originalCheckboxes[0]).trigger('change.filters', paginationPayload);
      } else if (handleFocus) {
        this.timedOutScrollToElement($focusElement);
      }
    });
  }

  timedOutScrollToElement($element) {
    setTimeout(()=> {
      this.scrollToElement($element);
    },500);
  }

  scrollToElement($element) {
    $element.get(0).scrollIntoView({block: "center", inline: "nearest", behavior: "smooth"});
  }

  // When the user clicks on filters, scroll to the top of the document
  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  bindSubmit() {
    this.$on('submit.filters', ({event}) => {
      event.preventDefault();
      let query = this.buildQuery();

      this.getPage(query).then(res => this.renderPage(res));

    }, this.main.dataset.filtersLayer);
  }

  render() {
    this.log('Load logics...');
    if (document.querySelector(this.SELECTORS.main)) {
      this.bindEvents();
      this.bindFilters();
      this.bindSubmit();
    }
    let filtersSelectedContainer = document.querySelector(this.main.dataset.filtersSelected);
  }
}
